import { DebounceTime, type HostedObserverConfig } from "@coze-studio/autosave";

import { type ParameterStoreProps } from "@rokid/store";
import { type ParameterConfig, ItemType } from "./type";
import {INPUT_PARAMETER_TYPE} from '@rokid/const'

type RegisterInputParameterConfig = HostedObserverConfig<
  ParameterStoreProps,
  ItemType,
  ParameterConfig
>;

export const inputParameterConfig: RegisterInputParameterConfig = {
  key: ItemType.InputParameter,
  selector: (store) => ({
    param_type: store.inputParameterType as INPUT_PARAMETER_TYPE,
  }),
  debounce: {
    default: DebounceTime.Immediate,
    customized_suggest_prompt: DebounceTime.Long,
  },
  middleware: {
    onBeforeSave: (dataSource) => ({
      param_config: dataSource,
    }),
  },
};
